var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReferCardImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.632,
    height: 25.12,
    viewBox: "0 0 27.632 25.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_72243",
    "data-name": "Path 72243",
    d: "M27.376,24.608V27.12H2.256V24.608H3.512V16.12A5.654,5.654,0,0,1,1.8,8.528L5.2,2.628A1.256,1.256,0,0,1,6.289,2H23.342a1.256,1.256,0,0,1,1.088.628l3.395,5.88A5.654,5.654,0,0,1,26.12,16.12v8.488ZM7.015,4.512,3.959,9.8a3.141,3.141,0,1,0,5.609,2.784,1.256,1.256,0,0,1,2.332,0,3.142,3.142,0,0,0,5.832,0,1.256,1.256,0,0,1,2.332,0,3.141,3.141,0,1,0,5.6-2.8L22.617,4.512Z",
    transform: "translate(-1 -2)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferCardImage);
export default __webpack_public_path__ + "static/media/referCardImage.a5c08f35b6a221dc7f1ebc90ef240f94.svg";
export { ForwardRef as ReactComponent };